module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-144x144.69b89dbba466251d13f4ad4d8e430a8f.png";